let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("c5uOY"), load("tLGOl")]).then(() => parcelRequire('anKEx'));